export default function unsaveInventoryItemActionCreator(savedInventoryDuck, authDuck, personalization) {
  return listing => async (dispatch, getState) => {
    const {
      id: listingId,
      bookmarkId = '',
      version
    } = listing;
    const {
      savedInventory = {}
    } = getState();
    const listingBookmarks = savedInventoryDuck.selectors.getSavedInventories({
      savedInventory
    }) || [];
    const isLoggedIn = authDuck.selectors.isLoggedIn(getState());
    const isListingBookmark = listingBookmarks.some(item => {
      if (typeof item === 'object') {
        return item.listingId === listingId;
      }
      return item === listingId;
    });
    const listingBookmark = isListingBookmark ? listing : {
      id: listingId,
      bookmarkId,
      version
    };
    personalization.setAuthenticated(isLoggedIn);

    // Update local save count in redux
    dispatch({
      type: savedInventoryDuck.types.REMOVE_SAVED_INVENTORY_ITEM,
      payload: listingId
    });
    try {
      const saveEvent = await personalization.unsaveInventoryItem(listingBookmark);
      switch (saveEvent.cacheType) {
        case 'remote':
          {
            if (saveEvent.bookmark) {
              if (saveEvent.bookmark.isDeleted) {
                // update local storage only when delete was successful
                const inventory = savedInventoryDuck.selectors.getSavedInventoryIds({
                  savedInventory
                });
                personalization.updateUserProfileCache({
                  carIds: inventory
                });
              } else {
                const message = saveEvent.messages && saveEvent.messages.error;
                dispatch(savedInventoryDuck.creators.setGlobalAlert({
                  key: 'serverFailure',
                  message
                }));
                if (saveEvent.bookmark.isSaved) {
                  // update save count if deletion fails
                  dispatch({
                    type: savedInventoryDuck.types.ADD_SAVED_INVENTORY_ITEM,
                    payload: {
                      listingId,
                      bookmarkId: saveEvent?.bookmark?.id,
                      version: saveEvent.version
                    }
                  });
                }
              }
            }
            break;
          }
        case 'local':
          {
            // TODO: myatc - do we need to handle failures here
            break;
          }
        default:
      }
      return saveEvent;
    } catch (error) {
      throw Error(error);
    }
  };
}